import {ContentfulContent, ObjectOfAny} from '../../../../types';

export default function addRefsToRichText(data: ContentfulContent): ObjectOfAny {
  const {raw = '', references = []} = data;
  const imagesPattern = /.*(png|jpg|jpeg|gif|svg)/i;
  try {
    const rawParsed = JSON.parse(raw);
    rawParsed.content.forEach((item: ObjectOfAny, index: string | number) => {
      if (item.nodeType === 'embedded-asset-block') {
        const contentfulId = item.data.target.sys.id;
        references.forEach((ref: ObjectOfAny) => {
          const isFound = ref.contentful_id === contentfulId;
          if (isFound && imagesPattern.test(ref.file.url)) {
            rawParsed.content[index].data.target.sys.file = {
              url: ref.file.url,
              title: ref.title,
              description: ref.description,
            };
          }
        });
      }
      if (item.nodeType === 'embedded-entry-block') {
        references.forEach((ref: ObjectOfAny) => {
          const contentfulId = item.data.target.sys.id;
          const isFound = ref.contentful_id === contentfulId;
          if (isFound) {
            // eslint-disable-next-line no-underscore-dangle
            if (ref.__typename === 'ContentfulAccordion') {
              rawParsed.content[index].data.target.sys.accordion = {
                items: ref.items,
              };
            } else if (ref.sys?.contentType?.sys?.id === 'ctaButtons') {
              rawParsed.content[index].data.target.sys = {
                title: ref.title,
                linkUrl: ref.linkUrl,
                variant: ref.variant,
                contentType: {
                  sys: {
                    id: ref.sys.contentType.sys.id,
                  },
                },
              };
            } else {
              // is an embeddable asset
              rawParsed.content[index].data.target.sys.file = {
                title: ref.title,
                description: ref.description,
                url: ref.url,
                embedType: ref.embedType,
              };
            }
          }
        });
      }
    });

    return rawParsed;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    return {};
  }
}
